import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ef-e-dockets-toe-filing',
  templateUrl: './e-dockets-toe-filing.component.html',
  styleUrls: ['./e-dockets-toe-filing.component.scss']
})
export class EDocketsToeFilingComponent implements OnInit {
  subscription:Subscription;
  constructor(private route:ActivatedRoute, private router: Router) {
    this.subscription=this.route.queryParams.subscribe(qParams => {
      if (!!qParams) {
       // localStorage.setItem("redirect", `/subsequent/filing?EventID=${qParams.EventID}&CaseID=${qParams.CaseID}&State=${qParams.stateID}&CourtLocation=${qParams["Default Court "]}&CaseNumber=${qParams["Case Number"]}`);    
        this.router.navigateByUrl(`/subsequent/filing?courtID=${qParams.courtID}&EventID=${qParams.EventID}&CaseID=${qParams.CaseID}&State=${qParams.stateID}&CourtLocation=${qParams["Default Court "]}&CaseNumber=${qParams["Case Number"]}`);
      } else {
        localStorage.setItem("redirect", "/");
      }
    });
   }

  ngOnInit() {
   
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
